import {ShapeCommand} from '../commands.template';
import {ConnectorJson} from './connector.commands';
import {setConnectionPoints} from '../../diagram-render/helpers/setConnectionPoints';

declare const mxUtils: any;

export class ConnectorDeleteCommand extends ShapeCommand {
  // protected firstAction: boolean;
  protected services: any;

  constructor(
    data,
    private readonly type: 'connector' | 'terminator'
  ) {
    super(data);
    // this.firstAction = true;
  }

  public execute() {
    super.execute();
    const graph = this.services.editorRegistrySvc.getGraph();

    graph.getModel().beginUpdate();
    // @TODO: check if this property exists
    // if (this.object.flowlines) {
    //   this.object.flowlines.forEach(flowline => {
    //     const flowlineCell = this.services.graphHelperSvc
    //       .allFlowlines()
    //       .find(cell => Number(cell.id) === Number(flowline.mxKey));
    //     flowlineCell.skipUndo = true;
    //   });
    // }

    const flowlineCell = this.services.graphHelperSvc
      .allFlowlines()
      .find(cell => Number(cell.id) === Number(this.object.flowlineMxKey));

    flowlineCell.skipUndo = true;
    const vertex = this.services.graphHelperSvc
      .allConnectorAndTerminators()
      .find(cell => Number(cell.id) === Number(this.object.mxKey));

    this.services.angularCompSvc.destroyComponent(vertex);
    graph.removeCells([vertex], false);
    this.executeJson(this.object);
    graph.getModel().endUpdate();
  }

  private executeJson(data: ConnectorJson) {
    return this.services.diagramUpdateSvc.update({
      [this.isConnector() ? 'deleteConnector' : 'deleteTerminator']: {
        flowlineMxKey: Number(data.flowlineMxKey)
      }
    });
  }

  public reverse() {
    super.reverse();
    const graph = this.services.editorRegistrySvc.getGraph();

    graph.getModel().beginUpdate();
    const vertex = this.isConnector()
      ? this.services.shapeSpawnerSvc.createConnector(this.object, this.object.flowlineMxKey)
      : this.services.shapeSpawnerSvc.createTerminator(this.object);

    this.services.angularCompSvc.setCache(vertex.id, vertex.comp);

    const flowlineCell = this.services.graphHelperSvc
      .allFlowlines()
      .find(cell => Number(cell.id) === Number(this.object.flowlineMxKey));

    flowlineCell.skipUndo = true;
    graph.model.setTerminal(flowlineCell, vertex, !!flowlineCell.target);
    setConnectionPoints(flowlineCell, graph);
    graph.addCell(vertex, this.services.graphHelperSvc.connectorAndTerminatorParent());
    this.reverseJson(this.object);
    graph.getModel().endUpdate();
  }

  private reverseJson(data: ConnectorJson) {
    const updatedJson = <ConnectorJson>{
      mxKey: Number(data.mxKey),
      flowlineMxKey: +data.flowlineMxKey,
      position: {
        x: data.position.x,
        y: data.position.y,
        w: data.position.w,
        h: data.position.h
      },
      customStyle: data.customStyle,
      styleObject: data.styleObject
    };

    if (data.srcType) {
      updatedJson.srcType = data.srcType;
    } else {
      updatedJson.tgtType = data.tgtType;
    }

    return this.services.diagramUpdateSvc.update({
      [this.isConnector() ? 'addConnector' : 'addTerminator']: updatedJson
    });
  }

  private isConnector() {
    return this.type === 'connector';
  }
}
